
<div>
    <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
            <a
                @click.stop = "onClick"
                v-bind = "attrs"
                v-on   = "on"
            >
                <v-icon
                    :size  = "size"
                    :color = "color"
                    :class = "ripple ? 'toolbar-button-ripple' : 'toolbar-button'"
                >
                    {{ icon }}
                </v-icon>
                <span v-if="label" style="font-size: 13px; margin-left: -2px;" :style="'color:' + color + '--text'">
                    {{ label }}
                </span>
            </a>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>

</div>
